<script>

        import { onMount } from 'svelte';

        export let currentQuestion;

        export let ansChanged;

        export let thisQUserResponses;

        export let questionVisited;

        export let language;

        export let mode = "";

        questionVisited({
            qId: currentQuestion._id
        })

        if(mode == "reattempt"){
           delete thisQUserResponses.answer;
        }

        function onChange(event) {
            MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
            if(mode == "reattempt"){
                thisQUserResponses.answer = event.currentTarget.value;
                mode = "review"
            }else{
                thisQUserResponses.answer = event.currentTarget.value;
                ansChanged({
                    qId: currentQuestion._id,
                    ans: thisQUserResponses.answer
                });
            }
            
        }

        let optionArr = [];

        for (const aProperty in currentQuestion.data) {
            if (Object.hasOwnProperty.call(currentQuestion.data, aProperty)) {
                const element = currentQuestion.data[aProperty];
                if(aProperty.indexOf('option_') == 0){
                    let optionName = aProperty.split("_")[1]; 
                    optionArr.push({
                        optionName: optionName,
                        option: element
                    })
                }
            }
        }

        onMount(async () => {
            MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
        })

</script>

<div class="q-option">
    <div class="q-label">
        Options :
    </div>
    <ul>

    {#each optionArr as aOption}
        <li class="correct option-li">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="op-label" style="position: relative;"
                class:correctly-answered={ mode=="review" && ((thisQUserResponses.answer == aOption.optionName) && (aOption.optionName == currentQuestion.data.answer))}
                class:correct-answer={mode=="review" && ((thisQUserResponses.answer != aOption.optionName) && (aOption.optionName == currentQuestion.data.answer))}
                class:wrongly-answered={mode=="review" && ((thisQUserResponses.answer == aOption.optionName) && (aOption.optionName != currentQuestion.data.answer))}
            >
            <div class="op-data-div">
                <div class="op-action">
                    {#if mode=="review"}
                
                        {#if ((thisQUserResponses.answer == aOption.optionName) && (aOption.optionName == currentQuestion.data.answer))}
                            <!-- this is correctly answered -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                        {:else if ((thisQUserResponses.answer != aOption.optionName) && (aOption.optionName ==  currentQuestion.data.answer))}
                            <!-- this is not answered but correct -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                        {:else if ((thisQUserResponses.answer == aOption.optionName) && (aOption.optionName != currentQuestion.data.answer))}
                            <!-- this is answered but wrong -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        {:else}
                            <div class="blank-option">
                        
                            </div>
                        {/if}
                
                    {:else}
                        <div class="option-action i-input">
                            <input type="radio" checked={thisQUserResponses.answer==aOption.optionName } on:change={onChange}
                                name="multipleChoiceOption_{currentQuestion?._id}" value={aOption.optionName} />
                            
                            <label></label>
                        </div>
                    {/if}
                </div>
                <div class="op-data">
                    <div class="option-content">{aOption.optionName}) &nbsp; {@html aOption.option[language]} </div>
                </div>
            </div>
            {#if mode=="review"}
                    {#if ((thisQUserResponses.answer == aOption.optionName) && (aOption.optionName == currentQuestion.data.answer))}
                        <div class="op-res-div" >
                            Your answer is correct
                        </div>
                    {:else if ((thisQUserResponses.answer != aOption.optionName) && (aOption.optionName ==  currentQuestion.data.answer))}
                        <div class="op-res-div ">
                            This is correct answer &nbsp;<span style="color:#E91E63">  (but was not selected)</span>
                        </div>

                    {:else if ((thisQUserResponses.answer == aOption.optionName) && (aOption.optionName != currentQuestion.data.answer))}
                        <div class="op-res-div wrong">
                            Your answer is wrong 
                        </div>

                    {/if}
            {/if}
            </label>
        </li> 
    {/each}
    </ul>
</div>